/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchMatchingHighlight
 */
export interface SourcingSearchMatchingHighlight {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchMatchingHighlight
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchMatchingHighlight
     */
    fragments: Array<string>;
}

/**
 * Check if a given object implements the SourcingSearchMatchingHighlight interface.
 */
export function instanceOfSourcingSearchMatchingHighlight(value: object): value is SourcingSearchMatchingHighlight {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('fragments' in value) || value['fragments'] === undefined) return false;
    return true;
}

export function SourcingSearchMatchingHighlightFromJSON(json: any): SourcingSearchMatchingHighlight {
    return SourcingSearchMatchingHighlightFromJSONTyped(json, false);
}

export function SourcingSearchMatchingHighlightFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchMatchingHighlight {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'fragments': json['fragments'],
    };
}

export function SourcingSearchMatchingHighlightToJSON(value?: SourcingSearchMatchingHighlight | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'fragments': value['fragments'],
    };
}

